import { Injectable, inject } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { MarketFeathersService } from './market-feathers.service';
import {
  ClientChatStatsItem,
  ClientChatStatsParams,
  ClientChatStatsResponse,
} from '@/core/models/client-chat-stats';

@Injectable({ providedIn: 'root' })
export class ClientChatStatsApiService {
  private readonly feathers = inject(MarketFeathersService);

  find(params: ClientChatStatsParams): Observable<ClientChatStatsResponse> {
    return this.feathers.currentUserSubject.pipe(
      filter((user) => !!user && user.id != null),
      take(1),
      switchMap(() => {
        const query: Record<string, unknown> = {
          $limit: params.$limit,
          $skip: params.$skip,
        };
        if (params.clientId != null) {
          query.clientId = params.clientId;
        }
        if (params.clientName) {
          query.clientName = params.clientName;
        }
        if (params.distributorId != null) {
          query.distributorId = params.distributorId;
        }
        if (params.fresh) {
          query.fresh = true;
        }

        return from(this.feathers.service('client-chat-stats').find({ query }) as Promise<ClientChatStatsResponse>);
      }),
      catchError((err) => {
        console.error('client-chat-stats error:', err?.message || err);
        return of({ total: 0, limit: params.$limit, skip: params.$skip, data: [] as ClientChatStatsItem[] });
      })
    );
  }

  findByClientId(clientId: number, distributorId?: number): Observable<ClientChatStatsItem | null> {
    return this.find({
      $limit: 1,
      $skip: 0,
      clientId,
      distributorId,
      fresh: true,
    }).pipe(map((res) => res.data?.find((item) => Number(item.clientId) === Number(clientId)) ?? res.data?.[0] ?? null));
  }
}
